module.exports = __webpack_public_path__ + "static/media/img-moduleB1.6f13715e.png";